import { Route } from '@angular/router';
import { accessGuard } from '@core';
import { MeterComponent } from '@feature/meter';

import { ExploreComponent } from '@feature/explore';
import { ReportComponent } from '@feature/report';
import { EMSDashboardComponent } from '../feature/dashboard/ems-dashboard.component';
import {
  GroupBaselineComponent,
  NotificationLogGroupBaselineComponent,
} from '@feature/baseline';

export const EMS_ROUTES: Route[] = [
  {
    path: 'dashboard',
    component: EMSDashboardComponent,
    data: {
      nav: {
        label: 'view_value.dashboard',
        icon: 'assets/shared/icons/widget.svg',
        mini_icon: 'assets/shared/icons/black/widget.svg',
        class: 'icon-50',
        order: 2,
      },
      access: { modules: ['EMS'] },
    },
    canMatch: [accessGuard],
  },
  {
    path: 'meter',
    component: MeterComponent,
    data: {
      nav: {
        label: 'view_value.meter',
        icon: 'assets/shared/icons/white/meter.svg',
        mini_icon: 'assets/shared/icons/black/meter.svg',
        class: 'icon-50',
        order: 20,
      },
      access: { modules: ['EMS'] },
    },
    canMatch: [accessGuard],
  },
  {
    path: 'explore',
    component: ExploreComponent,
    data: {
      nav: {
        label: 'view_value.explore',
        icon: 'assets/shared/icons/white/explor.svg',
        mini_icon: 'assets/shared/icons/black/explor.svg',
        class: 'icon-50',
        order: 30,
      },
      access: { modules: ['EMS'] },
    },
    canMatch: [accessGuard],
  },
  {
    path: 'group-baseline',
    data: {
      nav: {
        label: 'view_value.baseline',
        icon: 'assets/shared/icons/white/baseline.svg',
        mini_icon: 'assets/shared/icons/black/baseline.svg',
        class: 'icon-50',
        order: 40,
      },
      access: {
        modules: ['EMS'],
        // roles: ['Super Admin']
      },
    },
    canMatch: [accessGuard],
    children: [
      { path: '', component: GroupBaselineComponent },
      { path: 'history', component: NotificationLogGroupBaselineComponent },
    ],
  },
  {
    path: 'report',
    component: ReportComponent,

    data: {
      nav: {
        label: 'view_value.report',
        icon: 'assets/shared/icons/white/report.svg',
        mini_icon: 'assets/shared/icons/black/report.svg',
        class: 'icon-50',
        order: 60,
      },
      access: { modules: ['EMS'] },
    },
    canMatch: [accessGuard],
  },
];
